import { destroy, get, getOne, post, put } from "../apis/httpClient";

export const pagingPost = (params) => get('/api/v1/post/paging',params)
export const detailPost=(query)=>getOne(`/api/v1/post/detail/${query}`)
export const updatePost=(body)=>put(`/api/v1/post/update`,body)
export const createPost=(body)=>post(`/api/v1/post/create`,body)
export const deletePost = (body) => destroy(`/api/v1/post/delete`,body)